// src/redux/productSubCategorySlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeApiCall } from "../../makeAPICall";
import {
  PRODUCT_SUBCATEGORY_CONTROLLER,
  PRODUCT_SUBCATEGORY_PAGINATION_CONTROLLER,
} from "../../actionTypes";

export const getProductSubCategorysWithPagination = createAsyncThunk(
  "productSubCategory/getProductSubCategorysWithPagination",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "post",
        `/${PRODUCT_SUBCATEGORY_PAGINATION_CONTROLLER}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const saveProductSubCategory = createAsyncThunk(
  "productSubCategory/saveProductSubCategory",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "post",
        `/${PRODUCT_SUBCATEGORY_CONTROLLER}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const updateProductSubCategory = createAsyncThunk(
  "productSubCategory/updateProductSubCategory",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "put",
        `/${PRODUCT_SUBCATEGORY_CONTROLLER}/${obj.id}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);

export const getProductSubCategory = createAsyncThunk(
  "productSubCategory/getProductSubCategory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "get",
        `/${PRODUCT_SUBCATEGORY_CONTROLLER}/${id}`,

        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const deleteProductSubCategory = createAsyncThunk(
  "productSubCategory/deleteProductSubCategory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "delete",
        `/${PRODUCT_SUBCATEGORY_CONTROLLER}/${id}`,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const getProductSubCategorys = createAsyncThunk(
  "productCategory/getProductSubCategorys",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "get",
        `/${PRODUCT_SUBCATEGORY_CONTROLLER}`,

        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
const productSubCategorySlice = createSlice({
  name: "productSubCategory",
  initialState: {
    productSubCategorys: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductSubCategorysWithPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getProductSubCategorysWithPagination.fulfilled,
        (state, action) => {
          state.productSubCategorys = action.payload.data;
          state.loading = false;
          state.error = null;
        }
      )
      .addCase(
        getProductSubCategorysWithPagination.rejected,
        (state, action) => {
          state.productSubCategorys = [];
          state.loading = false;
          state.error = action.payload;
        }
      )

      .addCase(saveProductSubCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveProductSubCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(saveProductSubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProductSubCategorys.pending, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getProductSubCategorys.fulfilled, (state, action) => {
        const data = action.payload.data;
        state.productSubCategorys =
          data &&
          data.length > 0 &&
          data.map((x) => {
            return {
              label: x.name,
              value: x.id,
            };
          });
        state.loading = false;
        state.error = null;
      })
      .addCase(getProductSubCategorys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = productSubCategorySlice.actions;
export default productSubCategorySlice.reducer;
